import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Column } from 'ts/shared/interfaces/Generic';
import {
  faBed,
  faComment,
  faCutlery,
  faFootball,
  faMedkit,
  faPlane,
  faQuestion,
  faQuestionCircle,
  faRoad,
  faShip,
  faSuitcase,
  faTicket,
  faTrain,
  faCalendarAlt,
  faMoon,
  faHashtag,
  faDollarSign,
  faArrowDown91,
  faArrowDownLong,
  faArrowDownZA,
  faArrowUp19,
  faArrowUpAZ,
  faArrowUpLong,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const moTable: Column[] = [
  {
    label: '',
    field: 'productType',
    className: 'mo-row-icon w-35',
    format: 'icon',
    visible: true,
    alwaysVisible: true,
  },
  {
    label: 'Seg.',
    field: 'segmentId',
    format: 'segment',
    filter: true,
    visible: true,
    alwaysVisible: true,
    className: 'w-74',
  },
  {
    label: 'Docket',
    field: 'docket',
    filter: true,
    visible: true,
    alwaysVisible: true,
    className: 'mo-row-sm w-74',
  },

  { label: 'OrderId', field: 'orderId', filter: true, visible: false, alwaysVisible: false },
  {
    label: 'Supp.',
    field: 'suppPnr',
    filter: true,
    visible: true,
    alwaysVisible: true,
    className: 'w-74',
    format: 'jsx',
    helpField: 'suppPnrJsx',
  },
  {
    label: 'CheckIn',
    field: 'checkIn',
    filter: true,
    sortField: 'checkInDate',
    visible: true,
    alwaysVisible: true,
    className: 'text-right-important w-74',
  },
  {
    label: 'CheckOut',
    field: 'checkOut',
    sortField: 'checkOutDate',
    visible: true,
    alwaysVisible: false,
    className: 'text-right-important w-74',
  },
  { label: 'Nt.', field: 'nights', visible: false, alwaysVisible: false },
  { label: 'Seg. C', field: 'segCount', visible: false, alwaysVisible: false },
  { label: 'Product', field: 'product', filter: true, visible: false, alwaysVisible: false },
  { label: 'Supplier', field: 'supplier', filter: true, visible: false, alwaysVisible: false },
  { label: 'Department', field: 'department', filter: true, visible: false, alwaysVisible: false },
  { label: 'User C', field: 'userCode', filter: true, visible: false, alwaysVisible: false },
  {
    label: 'RqOk',
    field: 'rqOk',
    format: 'checkbox',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: 'IsDup',
    field: 'isDup',
    format: 'checkbox',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: 'ManualPNR',
    field: 'manualPnr',
    format: 'checkbox',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: 'HaveNotes',
    field: 'haveNotes',
    format: 'checkbox',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: 'HaveDocs',
    field: 'haveDocs',
    format: 'checkbox',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: 'HaveS.Rep.',
    field: 'haveSRep',
    format: 'checkbox',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: 'SegmentWasChangeDesc',
    field: 'segmentWasChangeDesc',
    format: 'checkbox',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: 'Name',
    field: 'name',
    className: 'mo-row-sm w-100',
    filter: true,
    visible: true,
    alwaysVisible: true,
    format: 'html',
    helpField: 'nameHtml',
  },
  {
    label: 'Dest.',
    field: 'dest',
    className: 'mo-row-sm w-100',
    filter: true,
    visible: true,
    alwaysVisible: true,
  },
  {
    label: 'Items',
    field: 'items',
    className: 'mo-row-yellow',
    filter: true,
    visible: true,
    alwaysVisible: true,
    format: 'jsx',
    helpField: 'itemsJsx',
  },
  {
    label: 'CLX',
    field: 'clx',
    filter: true,
    format: 'html',
    helpField: 'clxHtml',
    sortField: 'clxDate',
    visible: true,
    alwaysVisible: true,
    className: 'text-right-important w-63',
  },
  {
    label: 'S',
    field: 'status',
    format: 'status',
    filter: true,
    visible: true,
    alwaysVisible: true,
    className: 'w-35 text-center-important',
  },
  {
    label: 'V',
    field: 'voucher',
    format: 'checkbox',
    visible: true,
    alwaysVisible: true,
    className: 'w-35 text-center-important',
  },
  {
    label: 'Q',
    field: 'quantity',
    filter: true,
    visible: true,
    alwaysVisible: true,
    className: 'w-35',
  },
  {
    label: 'Total',
    field: 'total',
    className: 'text-right-important w-100',
    filter: true,
    sortField: 'totalNumber',
    visible: true,
    alwaysVisible: true,
  },
  {
    label: 'P',
    field: 'paymentType',
    format: 'payment',
    visible: true,
    alwaysVisible: true,
    className: 'w-35',
  },
  {
    label: 'Country',
    field: 'country',
    className: 'mo-row-sm w-63',
    visible: true,
    alwaysVisible: false,
  },
  { label: 'Original', field: 'original', visible: false, alwaysVisible: false },
  { label: 'Refund', field: 'refund', visible: false, alwaysVisible: false },
  { label: 'Refund NC', field: 'refundNc', visible: false, alwaysVisible: false },

  {
    label: 'Date C',
    field: 'dateC',
    format: 'jsx',
    helpField: 'dateCJsx',
    className: 'mo-row-sm w-74',
    visible: true,
    alwaysVisible: false,
  },
  {
    label: 'Ticket N.',
    field: 'ticketNumber',
    filter: true,
    visible: true,
    alwaysVisible: false,
    className: 'w-63',
  },

  { label: 'Agent', field: 'agent', className: 'mo-row-sm', visible: false, alwaysVisible: false },
  {
    label: 'Branch',
    field: 'branch',
    className: 'mo-row-sm',
    visible: false,
    alwaysVisible: false,
  },
  {
    label: '.',
    field: 'appOpn',
    format: 'jsx',
    helpField: 'appOpnHtml',
    visible: true,
    alwaysVisible: false,
    className: 'w-30 text-center-important',
  },
  {
    label: '.',
    field: 'appYes',
    format: 'jsx',
    helpField: 'appYesHtml',
    visible: true,
    alwaysVisible: false,
    className: 'w-30 text-center-important',
  },
  {
    label: '.',
    field: 'appArt',
    format: 'jsx',
    helpField: 'appArtHtml',
    visible: true,
    alwaysVisible: false,
    className: 'w-30 text-center-important',
  },
  {
    label: '.',
    field: 'appAgt',
    format: 'jsx',
    helpField: 'appAgtHtml',
    visible: true,
    alwaysVisible: false,
    className: 'w-30 text-center-important',
  },
];

export const getMoDetailsTable: (type?: string) => Column[] = (type?: string) => {
  const result: Column[] = [
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faCalendarAlt} className="mr-5" />
          Check in
        </span>
      ),
      helpLabel: 'checkIn',
      field: 'checkIn',
      label: '',
    },
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faCalendarAlt} className="mr-5" />
          Check out
        </span>
      ),
      field: 'checkOut',
      helpLabel: 'checkOut',
      label: '',
    },
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faMoon} className="mr-5" />
          Nights
        </span>
      ),
      helpLabel: 'nights',
      field: 'nights',
      label: '',
    },
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faBed} className="mr-5" />
          Rooms
        </span>
      ),
      helpLabel: 'roomsCount',
      field: 'roomsCount',
      label: '',
    },
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faHashtag} className="mr-5" />
          BePro #
        </span>
      ),
      helpLabel: 'bepro',
      field: 'bepro',
      format: 'jsx',
      helpField: 'beproHtml',
      label: '',
    },
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faTicket} className="mr-5" />
          Docket
        </span>
      ),
      helpLabel: 'docket',
      field: 'docket',
      label: '',
    },
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faDollarSign} className="mr-5" />
          Total
        </span>
      ),
      helpLabel: 'total',
      field: 'total',
      format: 'html',
      helpField: 'totalHtml',
      label: '',
    },
    { label: '', field: ' ' },
    {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faCalendarAlt} className="mr-5" />
          Creation
        </span>
      ),
      helpLabel: 'dateC',
      field: 'dateC',
      label: '',
    },
  ];

  if (type === 'HTL') {
    result.splice(2, 0, {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faRoad} className="mr-5" />
          Address
        </span>
      ),
      field: 'address',
      helpLabel: 'address',
      className: 'mo-group-address',
      label: '',
    });
    result.splice(5, 0, {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faHashtag} className="mr-5" />
          Zip
        </span>
      ),
      field: 'zip',
      helpLabel: 'zip',
      label: '',
    });
    result.splice(8, 0, { label: '', field: '' });
    result.splice(10, 1);
    result.push({
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faPhone} className="mr-5" />
          Phone
        </span>
      ),
      field: 'phone',
      helpLabel: 'phone',
      label: '',
    });
  } else if (type === 'FLT') {
    result.splice(2, 0, {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faComment} className="mr-5" />
          Time Limit
        </span>
      ),
      field: 'timeLimit',
      className: 'mo-group-title-danger',
      label: '',
    });
    result.splice(5, 0, {
      labelJsx: () => (
        <span>
          <FontAwesomeIcon icon={faPhone} className="mr-5" />
          Phone
        </span>
      ),
      field: 'phone',
      label: '',
    });
    result.splice(8, 0, { label: '', field: '' });
  }

  return result;
};

export const moPaxesTable: Column[] = [
  { label: '', field: 'index' },
  { label: 'Title', field: 'title' },
  { label: 'First Name', field: 'fn' },
  { label: 'Last Name', field: 'ln' },
  { label: 'Gender', field: 'gender' },
  { label: 'Birthday', field: 'birthday' },
  { label: 'Email', field: 'email' },
  { label: 'Phone', field: 'phone' },
];

export const moPaymentsTable: Column[] = [
  { label: '#', field: 'id' },
  { label: 'Status', field: 'status', format: 'icon', helpField: 'statusHelp' },
  { label: 'Tran. Id', field: 'transactionId' },
  { label: 'PTR Id', field: 'paymentTransactionResponseId' },
  { label: 'Reason', field: 'reason', format: 'show_more' },
  { label: 'Token', field: 'token', format: 'show_more' },
  { label: 'P', field: 'numberOfPayments' },
  { label: 'A', field: 'amount' },
  { label: 'T', field: 'paymentType', format: 'icon', helpField: 'paymentTypeClass' },
  { label: 'ErrCode', field: 'errCode', format: 'html', helpField: 'errCode' },
  { label: 'Date C', field: 'dateC' },
];

export const moDocTable: Column[] = [
  { label: 'File name', field: 'fileName' },
  { label: 'File type', field: 'type' },
  { label: 'Date Creation', field: 'dateC' },
  { label: '', field: 'open', format: 'jsx', helpField: 'openHtml' },
  { label: '', field: 'delete', format: 'jsx', helpField: 'deleteHtml' },
];

export const moRoomTable: Column[] = [
  { label: '', field: 'index' },
  { label: 'Room Description', field: 'room', className: 'text-bold text-st-important' },
  { label: 'P.', field: 'paxCount', format: 'jsx', helpField: 'paxCountJsx' },
  { label: 'Sta.', field: 'status', format: 'status' },
  { label: 'C.', field: 'ms' },
];

export const moCxlGroup: Column[] = [
  { label: 'Limit Date', field: '', format: 'html', helpField: 'limitDateHtml' },
  { label: 'Charge Conditions', field: '', format: 'html', helpField: 'cxlHtml' },
  { label: 'Supplier Note', field: '', format: 'html', helpField: 'supplier' },
];

export const moOwnerTable: Column[] = [
  { label: 'First Name', field: 'firstName' },
  { label: 'Last Name', field: 'lastName' },
  { label: 'Passport', field: 'passport' },
  { label: 'City', field: 'city' },
  { label: 'Address 1', field: 'adress_1' },
  { label: 'Address 2', field: 'adress_2' },
  { label: 'Country', field: 'country' },
  { label: 'Zip', field: 'zip' },
  { label: 'Phone', field: 'phone' },
  { label: 'Fax', field: 'fax' },
  { label: 'Mobile', field: 'mobile' },
  { label: 'Email', field: 'email' },
];

export const moParamsTable: Column[] = [
  { label: 'Param 1', field: 'param_1' },
  { label: 'Param 2', field: 'param_2' },
  { label: 'Param 3', field: 'param_3' },
  { label: 'Param 4', field: 'param_4' },
  { label: 'Param 5', field: 'param_5' },
];

export const moFlightTable: Column[] = [
  { label: 'PNR', field: 'pnr' },
  { label: 'Flight', field: 'flight', format: 'html', helpField: 'flightHtml' },
  { label: 'L.', field: 'legs' },
  { label: 'P.', field: 'paxes' },
  { label: 'Departure', field: 'departure', format: 'html', helpField: 'departureHtml' },
  { label: 'C.', field: 'depClassOfService' },
  { label: 'DateTime', field: 'depDateTime' },
  { label: 'Arrival', field: 'arrival', format: 'html', helpField: 'arrivalHtml' },
  { label: 'C.', field: 'arrClassOfService' },
  { label: 'DateTime', field: 'arrDateTime' },
  { label: 'Status', field: 'status', format: 'html', helpField: 'statusHtml' },
];

export const moSegmentTable: Column[] = [
  { label: 'PNR', field: 'pnr' },
  { label: 'Flight', field: 'flight' },
  { label: 'L.', field: 'legs' },
  { label: 'P.', field: 'paxes' },
  { label: 'Departure', field: 'departure', format: 'html', helpField: 'departureHtml' },
  { label: 'C.', field: 'depClassOfService' },
  { label: 'DateTime', field: 'depDateTime' },
  { label: 'Arrival', field: 'arrival', format: 'html', helpField: 'arrivalHtml' },
  { label: 'C.', field: 'arrClassOfService' },
  { label: 'DateTime', field: 'arrDateTime' },
  { label: 'Status', field: 'status' },
];

export const getMoSupplierTable: (supp: boolean) => Column[] = (supp: boolean) => {
  if (supp) {
    return [
      { label: 'Supplier Note', field: '', format: 'html', helpField: 'suppNote' },
      { label: 'Paid by Note', field: 'paidByNote' },
    ]
  } else {
    return [
      { label: 'Supplier Note', field: '', format: 'html', helpField: 'suppNote' },
      { label: 'SuppKey', field: 'suppKey' },
      { label: 'Paid by Note', field: 'paidByNote' },
      { label: 'Phone', field: '', format: 'html', helpField: 'phoneHtml' },
      { label: '', field: '', className: 'mo-group-empty' },
      { label: 'Emergency phone', field: '', format: 'html', helpField: 'emergencyPhoneHtml' },
      { label: '', field: '', className: 'mo-group-empty' },
      {
        label: 'Support email',
        field: '',
        format: 'jsx',
        helpField: 'helpDeskActions',
      },
      { label: '', field: '', className: 'mo-group-empty' },
      {
        label: 'Emergency email',
        field: '',
        format: 'jsx',
        helpField: 'emergencyActions',
      },
      { label: '', field: '', className: 'mo-group-empty' },
      { label: 'External', field: 'external' },
    ]
  }
};

export const moRemarksTable: Column[] = [
  { label: 'Remark Code', field: 'remarkCode', helpField: 'remarkCodeHelp', format: 'icon' },
  { label: 'Order Segment Remark Id', field: 'orderSegRemarkId' },
  { label: 'Description', field: 'desc' },
  { label: 'User', field: 'user' },
  { label: 'Date C', field: 'dateC' },
  { label: 'Close Reqest', field: 'closeReq', format: 'jsx', helpField: 'closeReq' }

];

export const moInfoTable: Column[] = [
  { label: 'Department', field: '', format: 'html', helpField: 'departmentHtml' },
  { label: 'Branch Phone', field: '', format: 'html', helpField: 'branchPhoneHtml' },
  { label: 'Branch', field: '', format: 'html', helpField: 'branchHtml' },
  { label: 'User Phone', field: '', format: 'html', helpField: 'userPhoneHtml' },
  { label: 'User', field: '', format: 'html', helpField: 'userHtml' },
  { label: '', field: '', className: 'mo-group-empty' },
  {
    label: 'User Mail',
    field: '',
    format: 'jsx',
    helpField: 'userMailJsx',
  },
  { label: '', field: '', className: 'mo-group-empty' },
];
export const moFlightData: Column[] = [
  { label: 'Internal Note', field: 'internalNote' },
  { label: 'BToken', field: 'bToken' },
  { label: 'SuppKey', field: 'suppKey' },
  { label: 'Public Note', field: 'publicNote' },
  { label: 'BePro #', field: 'beproId' },
  { label: 'SegDetailId', field: 'segDetailId' },
];

export const getIcon = (type: string | IconProp): IconProp => {
  if (typeof type === 'object') return type;
  switch (type) {
    case 'HTL':
      return faBed;
    case 'FLT':
      return faPlane;
    case 'TRN':
      return faTrain;
    case 'ACT':
      return faTicket;
    case 'TRS':
      return faRoad;
    case 'SMPK':
      return faSuitcase;
    case 'INS':
      return faMedkit;
    case 'SACT':
      return faFootball;
    case 'CRU':
      return faShip;
    case 'PCKM':
      return faQuestionCircle;
    case 'DTOR':
      return faQuestion;
    case 'MEALM':
      return faCutlery;
    default:
      return faComment;
  }
};

export const getStatus = (status: string): string => {
  switch (status.toUpperCase()) {
    case 'OK':
      return 'mo-status-success';
    case 'VOUCHER':
      return 'mo-status-info-3';
    case 'RQ':
    case 'ON REQUEST':
      return 'mo-status-info';
    case 'IP':
    case 'AP':
    case 'ERR':
      return 'mo-status-danger';
    case 'YK':
      return 'mo-status-info-2';
    default:
      return 'mo-status-secondary';
  }
};

export const getPayment = (status: string): string => {
  if (!status) return '';
  switch (status) {
    case 'Approved':
      return 'text-warning';
    case 'Success':
      return 'text-success';
    case 'Declined':
      return 'color-danger';
    default:
      return 'text-neutral';
  }
};

export const reasons1 = [
  { checked: false, key: 'mo.please_double_bed' },
  { checked: false, key: 'mo.please_twin_beds' },
  { checked: false, key: 'mo.please_high_floor' },
  { checked: false, key: 'mo.please_low_floor' },
  { checked: false, key: 'mo.please_non_smoking' },
  { checked: false, key: 'mo.please_smoking' },
  { checked: false, key: 'mo.please_adjoining_room' },
  { checked: false, key: 'mo.please_connecting_rooms' },
  { checked: false, key: 'mo.please_quiet_room' },
  { checked: false, key: 'mo.please_bathtub' },
  { checked: false, key: 'mo.please_accessible_room' },
];

const initData = { fullName: '_____', dob: '_____' };
export const reasons1Short = [
  { checked: false, key: 'mo.please_double_bed', visible: true, data: initData },
  { checked: false, key: 'mo.please_twin_beds', visible: true, data: initData },
  { checked: false, key: 'mo.please_adjoining_room', visible: false, data: initData },
  { checked: false, key: 'mo.please_connecting_rooms', visible: false, data: initData },
  { checked: false, key: 'mo.confirm_baby_cot', visible: false, data: initData },
  { checked: false, key: 'mo.add_confirm_baby_cot', visible: false, data: initData },
];

export const reasons2 = [
  { checked: false, key: 'mo.note_late_arrival' },
  { checked: false, key: 'mo.confirm_early_arrival' },
  { checked: false, key: 'mo.confirm_late_arrival' },
  { checked: false, key: 'mo.confirm_late_checkout' },
  { checked: false, key: 'mo.note_no_voucher' },
  { checked: false, key: 'mo.note_honeymoon' },
];

export const reasons3 = [{ checked: false, key: 'mo.confirm_baby_cot', data: initData }];
export const reasons4 = [{ checked: false, key: 'mo.add_confirm_baby_cot', data: initData }];

export const moLogTable: Column[] = [
  { label: '#', field: 'index', className: 'mo-row-sm', format: 'xsm' },
  { label: 'Log ID', field: 'orderLogId', className: 'mo-row-sm w-74', format: 'xsm' },
  { label: 'Date', field: 'dateC', className: 'w-130' },
  {
    label: 'E.',
    field: 'directionCode',
    className: 'mo-row-sm',
    format: 'jsx',
    helpField: 'directionCodeJsx',
  },
  {
    label: 'Subject',
    field: 'logSubject',
    className: 'w-130',
  },
  {
    label: 'Supp.',
    field: 'sysSuppCode',
    className: 'mo-row-sm w-63',
  },
  {
    label: 'Order Id',
    field: 'orderId',
    className: 'mo-row-sm w-63',
  },
  {
    label: 'Order Seg Id',
    field: 'orderSegId',
    className: 'mo-row-sm w-63',
  },
  {
    label: 'D.',
    field: 'actionCode',
    className: 'mo-row-sm',
    format: 'jsx',
    helpField: 'actionCodeJsx',
  },
  { label: 'Com.', field: 'companyId', className: 'mo-row-sm', format: 'xsm' },
  {
    label: 'Dep.',
    field: 'departmentId',
    className: 'mo-row-sm',
    format: 'xsm',
  },
  {
    label: 'Branch',
    field: 'branchId',
    className: 'mo-row-sm',
    format: 'xsm',
  },
  { label: 'User', field: 'userCodeC', className: 'mo-row-sm', format: 'xsm' },
].map((column) => ({
  ...(column as any),
  visible: true,
  alwaysVisible: true,
}));

export enum MainMoFilter {
  NoFilter = '',
  OnlyDuplication = '1',
  CXLLess24Hours = '2',
  CXLLess48Hours = '3',
  CXLLess72Hours = '4',
  CXLLess96Hours = '5',
  OnlyWithTemporaryNames = '6',
  Open = '7',
  Close = '8',
  RefundReport = '9',
  ChangeNameReport = '10',
  KeepDelRows = '11',
  LastMonthSegments = '12',
  CurrentMonthSegments = '13',
  CouponCode = '14',
}

export const moSearchFilter = [
  { label: 'No Filter', value: MainMoFilter.NoFilter },
  { label: 'Only Duplication', value: MainMoFilter.OnlyDuplication },
  { label: 'CXL: less 24 hours', value: MainMoFilter.CXLLess24Hours },
  { label: 'CXL: less 48 hours', value: MainMoFilter.CXLLess48Hours },
  { label: 'CXL: less 72 hours', value: MainMoFilter.CXLLess72Hours },
  { label: 'CXL: less 96 hours', value: MainMoFilter.CXLLess96Hours },
  { label: 'Only with Temporary names', value: MainMoFilter.OnlyWithTemporaryNames },
  { label: 'Open (OP-)', value: MainMoFilter.Open },
  { label: 'Close (CP-)', value: MainMoFilter.Close },
  { label: 'Refund Report', value: MainMoFilter.RefundReport },
  { label: 'Change Name Report', value: MainMoFilter.ChangeNameReport },
  {
    label: 'Keep DelRows',
    value: MainMoFilter.KeepDelRows,
    html: <span className="color-danger">Keep DelRows</span>,
  },
  {
    label: 'Last Month Segments',
    value: MainMoFilter.LastMonthSegments,
    html: <span className="text-success">Last Month Segments</span>,
  },
  {
    label: 'Current Month Segments',
    value: MainMoFilter.CurrentMonthSegments,
    html: <span className="text-warning">Current Month Segments</span>,
  },
  { label: 'Coupon Code', value: MainMoFilter.CouponCode },
];


export const moStarsOptions = [
  { value: '1', label: '1' },
  { value: '1.5', label: '1.5' },
  { value: '2', label: '2' },
  { value: '2.5', label: '2.5' },
  { value: '3', label: '3' },
  { value: '3.5', label: '3.5' },
  { value: '4', label: '4' },
  { value: '4.5', label: '4.5' },
  { value: '5', label: '5' },
];

export const moSortOptions = [
  {
    value: 'priceIncrease',
    label: 'Price (Low to High)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowUp19} className="mr-10 text-success" />
        Price (Low to High)
      </div>
    ),
  },
  {
    value: 'priceDecrease',
    label: 'Price (High to Low)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowDown91} className="mr-10 color-danger" />
        Price (High to Low)
      </div>
    ),
  },
  {
    value: 'creationDateIncrease',
    label: 'Creation Date (Oldest First)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowUpLong} className="mr-10 text-success" />
        Creation Date (Oldest First)
      </div>
    ),
  },
  {
    value: 'creationDateDecrease',
    label: 'Creation Date (Newest First)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowDownLong} className="mr-10 color-danger" />
        Creation Date (Newest First)
      </div>
    ),
  },
  {
    value: 'checkInIncrease',
    label: 'Check In (Earliest First)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowUpLong} className="mr-10 text-success" />
        Check In (Earliest First)
      </div>
    ),
  },
  {
    value: 'checkInDecrease',
    label: 'Check In (Latest First)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowDownLong} className="mr-10 color-danger" />
        Check In (Latest First)
      </div>
    ),
  },
  {
    value: 'CXLDateIncrease',
    label: 'CXL Date (Earliest First)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowUpLong} className="mr-10 text-success" />
        CXL Date (Earliest First)
      </div>
    ),
  },
  {
    value: 'CXLDateDecrease',
    label: 'CXL Date (Latest First)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowDownLong} className="mr-10 color-danger" />
        CXL Date (Latest First)
      </div>
    ),
  },
  {
    value: 'segmentIdIncrease',
    label: 'Segment ID (1-9)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowUp19} className="mr-10 text-success" />
        Segment ID (A-Z)
      </div>
    ),
  },
  {
    value: 'segmentIdDecrease',
    label: 'Segment ID (9-1)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowDown91} className="mr-10 color-danger" />
        Segment ID (Z-A)
      </div>
    ),
  },
  {
    value: 'itemNameIncrease',
    label: 'Item Name (A-Z)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowUpAZ} className="mr-10 text-success" />
        Item Name (A-Z)
      </div>
    ),
  },
  {
    value: 'itemNameDecrease',
    label: 'Item Name (Z-A)',
    html: (
      <div>
        <FontAwesomeIcon icon={faArrowDownZA} className="mr-10 color-danger" />
        Item Name (Z-A)
      </div>
    ),
  },
]